/** Mirrors server/lib/profileCompletion.js field checks for onboarding UI. */

/** Default DOB when roster has no date — member must replace at first login. */
export const ROSTER_DOB_PLACEHOLDER = '01/01/1990';

function isParseableDobString(dob) {
  const s = String(dob || '').trim();
  if (!s) return false;
  return (
    /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(s) ||
    /^\d{1,2}-\d{1,2}-\d{4}$/.test(s) ||
    /^\d{4}-\d{2}-\d{2}$/.test(s)
  );
}

export function needsProfileMobile(user) {
  const mobileDigits = String(user?.mobile || '').replace(/\D/g, '');
  return !/^\d{10}$/.test(mobileDigits);
}

export function needsProfileAddress(user) {
  const address = String(user?.address || '').trim();
  const pincode = String(user?.pincode || '').trim();
  return !address || !/^\d{6}$/.test(pincode);
}

export function needsProfileDob(user) {
  const raw = String(user?.dob || '').trim();
  if (!raw || raw === ROSTER_DOB_PLACEHOLDER) return true;
  return !isParseableDobString(raw);
}

export function needsProfileCompletion(user) {
  return needsProfileMobile(user) || needsProfileAddress(user) || needsProfileDob(user);
}
